import { Component, Input, OnInit } from '@angular/core';
import { TicketButtonCommunicationDto, TicketDto, TicketHistoryCapturedFieldDto, TicketHistoryDto } from '../../../../../service/dto';
import { HttpTicketService } from '../../../../../service/http-ticket.service';
import { HttpFileService } from '../../../../../service/http-file.service';

@Component({
  selector: 'app-ticket-history',
  standalone: false,
  templateUrl: './ticket-history.component.html',
  styleUrl: './ticket-history.component.scss'
})
export class TicketHistoryComponent implements OnInit{
	@Input() ticket!: TicketDto;
	history?: TicketHistoryDto;

	constructor(private service: HttpTicketService, private fileService: HttpFileService){

	}
	ngOnInit(): void {
		this.service.getTicketHistory(this.ticket.id).subscribe(result => this.history = result);
	}

	doDownload(input: TicketHistoryCapturedFieldDto){
		this.fileService.downloadFile(input.inputValue!).subscribe();
	}
}
